import React from 'react';
import {
  CContainer,
  CRow,
  CCol,
  CCard,
  CCardBody,
  CCardHeader,
  CBreadcrumb,
  CBreadcrumbItem,
} from '@coreui/react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import YarnInputs from '../../components/YarnInputs/YarnInputs';
import { connect } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import { updateYarnRequestAction } from '../../store/yarn/yarnActions';

const UpdateYarn = ({ updateYarnRequest, isLoading, updateYarnData }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const yarnData = location.state?.yarn || null;
  const { t } = useTranslation();

  const handleSubmit = (data) => {
    updateYarnRequest({ data, navigate });
  };

  const handleCancel = () => {
    navigate('/yarn');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/yarn" onClick={(e) => { e.preventDefault(); handleCancel(); }}>
          {t('Yarn')}
        </CBreadcrumbItem>
        <CBreadcrumbItem active>{t('updateYarn')}</CBreadcrumbItem>
      </CBreadcrumb>

      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader>
              <h4>{t('updateYarn')}</h4>
              {yarnData?.YarnId && (
                <small className="text-muted">{t('ID')}: {yarnData.YarnId}</small>
              )}
            </CCardHeader>
            <CCardBody>
              {yarnData ? (
                <YarnInputs
                  onSubmit={handleSubmit}
                  onCancel={handleCancel}
                  isLoading={isLoading}
                  submitResponse={updateYarnData}
                  initialData={yarnData}
                  isEdit={true}
                />
              ) : (
                <div className="text-center py-4">
                  <div className="text-muted">{t('Yarn data not found.')}</div>
                  <button className="btn btn-primary mt-3" onClick={handleCancel}>
                    {t('Back to Yarn List')}
                  </button>
                </div>
              )}
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.loadingReducer?.isLoading || false,
  updateYarnData: state.yarnReducer?.updateYarnData || null,
});

const mapDispatchToProps = (dispatch) => ({
  updateYarnRequest: (payload) => dispatch(updateYarnRequestAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateYarn);
